import { useState } from 'react';

import { IWidgetCard } from '@entities/widget-card/model/types';

import { useAddFreeWidgetQuery } from './useAddFreeWidgetQuery';

export const useAddFreeWidget = () => {
    const addFreeWidgetMutation = useAddFreeWidgetQuery();
    const [pendingWidgetId, setPendingWidgetId] = useState<IWidgetCard['id'] | null>(null);

    const handleAddFreeWidget = (widgetId: IWidgetCard['id'], notMyCompany = false) => {
        setPendingWidgetId(widgetId);

        addFreeWidgetMutation.mutate(
            { widgetId, notMyCompany },
            {
                onSettled: () => {
                    setPendingWidgetId(null);
                },
            }
        );
    };

    return {
        handleAddFreeWidget,
        pendingWidgetId,
    };
};
